import React, { useCallback, useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FaFilter } from 'react-icons/fa';
import { Button, Card, Title } from 'src/components';
import DashboardCard from 'src/components/DashboardCard';
import ExportCSVButton from 'src/components/ExportCSVButton';
import Loader from 'src/components/loader';
import DashboardTable from 'src/components/table/dashboardTable';
import Service from 'src/setup/network';
import LineChart from './__chart__data/linechart';
import jsPDF from 'jspdf';
import NoDataShown from 'src/components/noResult';
import { Link } from 'react-router-dom';
// import 'jspdf-autotable';
import UpcomingFeature from 'src/components/commingSoon';
import OnlineOrdering from '../restaurant/details/OnlineOrdering';
import { RootState } from 'src/redux/reducers';
import { useSelector } from 'react-redux';
import SubscriptionInfo from './SubscriptionInfo';

interface IProps {}

const filterOption = [
  {
    id: 1,
    title: 'Today',
    label: 'today',
  },
  {
    id: 2,
    title: 'Yesterday',
    label: 'yesterday',
  },
  {
    id: 3,
    title: 'This Week',
    label: 'this_week',
  },
  {
    id: 4,
    title: 'Last Week',
    label: 'last_week',
  },
  {
    id: 5,
    title: 'This Month',
    label: 'this_month',
  },
  {
    id: 6,
    title: 'Last Month',
    label: 'last_month',
  },
  {
    id: 7,
    title: 'Last 7 Days',
    label: 'last_seven_days',
  },
  {
    id: 8,
    title: 'Last 30 Days',
    label: 'last_thirty_days',
  },
];
const tableColumn = [
  {
    Header: 'Item Name',
    accessor: 'name',
    Cell: (row: any) => (
      <div className="flex items-center space-x-3">
        <p className="text-text-black"> {row?.cell?.row?.original?.name}</p>
      </div>
    ),
  },
  { Header: 'Price', accessor: 'price' },
  {
    Header: 'Item Sold',
    accessor: 'quantity',
  },

  {
    Header: 'Net Sales',
    accessor: 'amount',
  },
];
const paymentColumn = [
  {
    Header: 'Method',
    accessor: 'name',
  },
  {
    Header: 'Amount',
    accessor: 'amount',
  },
  { Header: 'Rate', accessor: 'rate' },
];
const typeColumn = [
  {
    Header: 'Order Type',
    accessor: 'name',
  },
  { Header: 'Sales', accessor: 'amount' },
  // {
  //   Header: 'Avg Sales',
  //   accessor: '20000',
  // },
];

const taxColumn = [
  {
    Header: 'Charge Title',
    accessor: 'name',
  },
  // { Header: 'Rate', accessor: 'value' },
  {
    Header: 'Amount',
    accessor: 'amount',
  },
];

const employeeColumn = [
  {
    Header: 'Employee Name',
    accessor: 'name',
    Cell: (row: any) => (
      <div className="flex items-center space-x-3">
        {/* <img
          src={
            'https://cdn.pixabay.com/photo/2016/08/20/05/38/avatar-1606916_960_720.png'
          }
          alt="employee-photo"
          className="w-8 h-8 rounded-full object-cover"
        /> */}
        <div className="capitalize w-8 h-8 rounded-full bg-[black] text-[white]  text-xl   flex items-center justify-center">
          {row.cell.row.original.name[0]}
        </div>
        <p className="text-text-black"> {row?.cell?.row?.original?.name}</p>
      </div>
    ),
  },
  { Header: 'Sales', accessor: 'price' },
];
const BackOffice: React.FC<IProps> = ({}) => {
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);
  const [tableInfo, setTableInfo] = useState<any>([]);
  const [siteUrlQr, setSiteUrlQr] = useState<any>([]);
  const [qrimg, setQrImg] = useState<any>('');
  const [siteLink, SetSiteLink] = useState<any>('');
  const [cardInfo, setCardInfo] = useState<any>([]);
  const [date, setDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingQR, setIsLoadingQR] = useState(false);
  const [isError, setIsError] = useState(null);
  const [graphData, setGraphData] = useState([]);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [filterValue, setFilterValue] = useState('this_month');
  const [filterLabel, setFilterLabel] = useState('This Month');
  const [isFirstRender, setIsFirstRender] = useState(true);

  const imgRef = useRef(null);

  const handleDownload = async (imageUrl: string) => {
    // Load the image from the URL
    const imgElement = new Image();
    imgElement.crossOrigin = 'anonymous'; // Enable cross-origin for the image
    imgElement.src = imageUrl;

    // Wait for the image to load
    await new Promise((resolve) => {
      imgElement.onload = resolve;
    });
    // Create a temporary canvas
    const tempCanvas = document.createElement('canvas');
    const tempCtx: any = tempCanvas.getContext('2d');
    tempCanvas.width = 250;
    tempCanvas.height = 250;

    // Draw the image on the temporary canvas
    tempCtx.drawImage(imgElement, 0, 0);

    // Get the image data
    const imageData = tempCtx.getImageData(
      0,
      0,
      tempCanvas.width,
      tempCanvas.height
    );

    // Find the non-transparent boundaries
    let minX = tempCanvas.width;
    let minY = tempCanvas.height;
    let maxX = -1;
    let maxY = -1;

    for (let y = 0; y < tempCanvas.height; y++) {
      for (let x = 0; x < tempCanvas.width; x++) {
        const alpha = imageData.data[(y * tempCanvas.width + x) * 4 + 3];
        if (alpha > 0) {
          minX = Math.min(minX, x);
          minY = Math.min(minY, y);
          maxX = Math.max(maxX, x);
          maxY = Math.max(maxY, y);
        }
      }
    }

    // Calculate the trimmed width and height
    const trimmedWidth = maxX - minX + 1;
    const trimmedHeight = maxY - minY + 1;

    // Create a new canvas for the trimmed image
    const trimmedCanvas = document.createElement('canvas');
    const trimmedCtx: any = trimmedCanvas.getContext('2d');
    trimmedCanvas.width = trimmedWidth;
    trimmedCanvas.height = trimmedHeight;

    // Draw the trimmed image on the new canvas
    trimmedCtx.drawImage(
      tempCanvas,
      minX,
      minY,
      trimmedWidth,
      trimmedHeight,
      0,
      0,
      trimmedWidth,
      trimmedHeight
    );

    // Convert the trimmed image to data URL
    const trimmedDataUrl = trimmedCanvas.toDataURL('image/png');

    // Create a link and trigger the download
    const link = document.createElement('a');
    link.href = trimmedDataUrl;
    link.setAttribute('download', 'trimmed_image.png');

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  // const handleDownload = () => {
  //   fetch(imgRef.current.src)
  //     .then((response) => response.blob())
  //     .then((blob) => {
  //       const url = window.URL.createObjectURL(new Blob([blob]));
  //       const link = document.createElement('a');
  //       link.href = url;
  //       link.setAttribute('download', 'downloaded_image.png');

  //       document.body.appendChild(link);

  //       link.click();

  //       document.body.removeChild(link);
  //     })
  //     .catch((error) => console.error('Error downloading image:', error));
  // };

  const handleDateChange = (dates: any) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };
  // useEffect(() => {
  //   setFilterValue('custom_date');
  // }, [startDate && endDate]);

  useEffect(() => {
    if (isFirstRender) {
      setFilterValue('this_month');
      setIsFirstRender(false);
    } else if (startDate && endDate) {
      setFilterValue('custom_date');
    }
  }, [startDate, endDate]);

  const [showFilterOption, setShowFilterOtion] = useState(false);

  const handleClick = () => {
    setShowFilterOtion(!showFilterOption);
  };

  const fetchDashBoardData = useCallback(async () => {
    setIsLoading(true);
    try {
      let response;
      if (filterValue === 'custom_date' && startDate && endDate) {
        response = await Service.get(
          `dashboard/temp?dateFilterType=custom&from=${new Date(
            startDate.toString()
          ).toISOString()}&to=${new Date(endDate.toString()).toISOString()}`
        );
        setShowFilterOtion(false);
      } else {
        response = await Service.get(
          `dashboard/temp?dateFilterType=${filterValue}&from=&to=`
        );
      }
      const data = await response?.data;
      setGraphData(data?.graphData);
      setQrImg(data?.airMenuQr);
      SetSiteLink(data?.airMenuLink);
      // setTableInfo(data?.tableInfo);
      // setCardInfo(data?.cardInfo);
      setIsLoading(false);
    } catch (err: any) {
      setIsError(err);
      setIsLoading(false);
    }
  }, [filterValue, startDate, endDate]);

  const fetchQRData = useCallback(async () => {
    setIsLoadingQR(true);
    try {
      let response = await Service.get(
        `dashboard/qr-codes`
      );
      const data = await response?.data?.qrCodes || [];
      setSiteUrlQr(data)
      setIsLoadingQR(false);
    } catch (err: any) {
      setIsError(err);
      setIsLoadingQR(false);
    }
  }, []);

  useEffect(()=>{
    fetchQRData()
  },[])

  useEffect(() => {
    if (filterValue === 'custom_date' && startDate && endDate) {
      fetchDashBoardData();
    } else if (filterValue !== 'custom_date') {
      fetchDashBoardData();
    }
  }, [fetchDashBoardData, filterValue, startDate, endDate]);

  // const fetchDashBoardData = useCallback(async () => {
  //   setIsLoading(true);
  //   try {
  //     const response = await Service.get(
  //       `dashboard?dateFilterType=${filterValue}&from=&to=`
  //     );
  //     const data = await response?.data;
  //     setGraphData(data?.grossSalesGraphData);
  //     setTableInfo(data?.tableInfo);
  //     setCardInfo(data?.cardInfo);
  //     setIsLoading(false);
  //   } catch (err: any) {
  //     setIsError(err);
  //     setIsLoading(false);
  //   }
  // }, [filterValue]);
  // useEffect(() => {
  //   fetchDashBoardData();
  // }, [fetchDashBoardData]);

  // just a sample data for backoffice to export as a CSV file
  const sampleData = [
    { id: 1, name: 'John', age: 30 },
    { id: 2, name: 'Jane', age: 25 },
    { id: 3, name: 'Doe', age: 40 },
  ];

  const exportToPDF = () => {
    const pdf = new jsPDF('p', 'mm', 'a4');

    // Replace 'pdf-content' with the ID of the container you want to export
    const content: any | null = document.getElementById('back-office');

    pdf.html(content as any, {
      callback: () => {
        pdf.save('exported_document.pdf');
      },
    });
  };

  // alert(qrimg);
  return (
    <>
      {isLoading && <Loader />}
      <div id="back-office">
        <SubscriptionInfo />
        <div className="mt-8 pb-8 flex justify-between w-full  text-black">
          <div className="flex flex-col gap-5 w-auto">
            <div className="w-full text-sm font-normal leading-[21px]">
              Restaurant Link
            </div>

            {isLoadingQR && <div className="w-52 h-max flex gap-5 p-4 rounded-lg border border-[#F1F0F6]">
              {Array.from({ length: 1 }).map((_, index) => (
                <div
                  key={index}
                  className={`flex flex-col w-full gap-3 animate-pulse`}
                >
                  {/* Title + QR button */}
                  <div className="flex justify-between items-center">
                    <div className="h-4 w-24 bg-[#F1F0F6] rounded" />
                    <div className="h-7 w-12 bg-[#F1F0F6] rounded-xl" />
                  </div>

                  {/* URL */}
                  <div className="h-3 w-36 bg-[#F1F0F6] rounded" />

                  {/* QR image */}
                  <div className="w-full max-w-[50%] m-auto mt-2 bg-[#00000004] rounded">
                    <div className="aspect-square w-full bg-[#F1F0F6] rounded-md" />
                  </div>
                </div>
              ))}
            </div>}


            <div className="w-auto h-max flex gap-5 p-4 rounded-lg border border-[#F1F0F6]">
              {siteUrlQr?.map((item: any, index: number) => (
                <div
                  className={`flex flex-col gap-3 ${
                    siteUrlQr.length !== index + 1 &&
                    'border-r-2 border-[#F1F0F6] pr-5'
                  }`}
                >
                  <div className="flex justify-between items-center">
                    <h2 className="text-sm font-semibold">{item?.title}</h2>
                    <button
                      onClick={() =>
                        handleDownload(
                          item?.image
                            .toLowerCase()
                            .includes('data:image/png;base64,')
                            ? item?.image
                            : 'data:image/png;base64,' + item?.image
                        )
                      }
                      className="flex justify-between items-center text-[10px] bg-primary  gap-2 pl-2 pr-2 py-2 rounded-xl text-pure-white font-semibold"
                    >
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 20 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.2"
                          d="M13.125 9.25L10 12.375L6.875 9.25H13.125Z"
                          fill="white"
                        />
                        <path
                          d="M17.5 12.375V16.75C17.5 17.0815 17.3683 17.3995 17.1339 17.6339C16.8995 17.8683 16.5815 18 16.25 18H3.75C3.41848 18 3.10054 17.8683 2.86612 17.6339C2.6317 17.3995 2.5 17.0815 2.5 16.75V12.375C2.5 12.2092 2.56585 12.0503 2.68306 11.9331C2.80027 11.8158 2.95924 11.75 3.125 11.75C3.29076 11.75 3.44973 11.8158 3.56694 11.9331C3.68415 12.0503 3.75 12.2092 3.75 12.375V16.75H16.25V12.375C16.25 12.2092 16.3158 12.0503 16.4331 11.9331C16.5503 11.8158 16.7092 11.75 16.875 11.75C17.0408 11.75 17.1997 11.8158 17.3169 11.9331C17.4342 12.0503 17.5 12.2092 17.5 12.375ZM6.43281 9.69219C6.34531 9.60478 6.2857 9.49337 6.26154 9.37207C6.23739 9.25076 6.24977 9.12502 6.29711 9.01076C6.34446 8.89649 6.42464 8.79884 6.52751 8.73018C6.63038 8.66151 6.75132 8.6249 6.875 8.625H9.375V3.625C9.375 3.45924 9.44085 3.30027 9.55806 3.18306C9.67527 3.06585 9.83424 3 10 3C10.1658 3 10.3247 3.06585 10.4419 3.18306C10.5592 3.30027 10.625 3.45924 10.625 3.625V8.625H13.125C13.2487 8.6249 13.3696 8.66151 13.4725 8.73018C13.5754 8.79884 13.6555 8.89649 13.7029 9.01076C13.7502 9.12502 13.7626 9.25076 13.7385 9.37207C13.7143 9.49337 13.6547 9.60478 13.5672 9.69219L10.4422 12.8172C10.3841 12.8753 10.3152 12.9214 10.2393 12.9529C10.1635 12.9843 10.0821 13.0005 10 13.0005C9.91787 13.0005 9.83654 12.9843 9.76066 12.9529C9.68479 12.9214 9.61586 12.8753 9.55781 12.8172L6.43281 9.69219ZM8.38594 9.875L10 11.4914L11.6164 9.875H8.38594Z"
                          fill="white"
                        />
                      </svg>
                      QR
                    </button>
                  </div>
                  <Link
                    to={item?.url}
                    className="flex gap-[6px] items-center text-xs text-primary leading-[18px]"
                  >
                    {item?.url}
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.5 4.875C10.5 4.97446 10.4605 5.06984 10.3902 5.14016C10.3198 5.21049 10.2245 5.25 10.125 5.25C10.0255 5.25 9.93016 5.21049 9.85983 5.14016C9.78951 5.06984 9.75 4.97446 9.75 4.875V2.78062L6.64078 5.89031C6.57042 5.96068 6.47498 6.00021 6.37547 6.00021C6.27596 6.00021 6.18052 5.96068 6.11016 5.89031C6.03979 5.81995 6.00026 5.72451 6.00026 5.625C6.00026 5.52549 6.03979 5.43005 6.11016 5.35969L9.21937 2.25H7.125C7.02554 2.25 6.93016 2.21049 6.85983 2.14016C6.78951 2.06984 6.75 1.97446 6.75 1.875C6.75 1.77554 6.78951 1.68016 6.85983 1.60984C6.93016 1.53951 7.02554 1.5 7.125 1.5H10.125C10.2245 1.5 10.3198 1.53951 10.3902 1.60984C10.4605 1.68016 10.5 1.77554 10.5 1.875V4.875ZM8.625 6C8.52554 6 8.43016 6.03951 8.35983 6.10983C8.28951 6.18016 8.25 6.27554 8.25 6.375V9.75H2.25V3.75H5.625C5.72446 3.75 5.81984 3.71049 5.89016 3.64016C5.96049 3.56984 6 3.47446 6 3.375C6 3.27554 5.96049 3.18016 5.89016 3.10984C5.81984 3.03951 5.72446 3 5.625 3H2.25C2.05109 3 1.86032 3.07902 1.71967 3.21967C1.57902 3.36032 1.5 3.55109 1.5 3.75V9.75C1.5 9.94891 1.57902 10.1397 1.71967 10.2803C1.86032 10.421 2.05109 10.5 2.25 10.5H8.25C8.44891 10.5 8.63968 10.421 8.78033 10.2803C8.92098 10.1397 9 9.94891 9 9.75V6.375C9 6.27554 8.96049 6.18016 8.89017 6.10983C8.81984 6.03951 8.72446 6 8.625 6Z"
                        fill="#4062FF"
                      />
                    </svg>
                  </Link>
                  <img
                    className="w-full  max-w-[50%]  m-auto mt-2 bg-[#00000004]"
                    src={
                      item?.image
                        ?.toLowerCase()
                        ?.includes('data:image/png;base64,')
                        ? item?.image
                        : 'data:image/png;base64,' + item?.image
                    }
                    alt="Qr code Image"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(BackOffice);
